import ApiClient from '../ApiClient';

const appId = process.env.REACT_APP_DEFAULT_APP_ID; //pass the app ID based on login

const UserService = {

  async userRegistration(userData) {
    try {
      console.log("userData", userData);
      const resp = await ApiClient.post("/Auth/user-registration", userData);
      return resp;
    } catch (error) {
      console.error("❌ Error registering user:", error.response?.data || error.message);
      throw error;
    }
  },

  async fetchUserProfile() {
    try {
      const resp = await ApiClient.get("/User/get-user-profile");
      return resp;
    } catch (error) {
      console.error("❌ Error fetching user profile:", error.response?.data || error.message);
      throw error;
    }
  },

  async updateUserCompany(companyData, companyLogo) {
    try {
      const formData = new FormData();

      formData.append("CompanyName", companyData.companyName || "");
      formData.append("CompanyTagline", companyData.companyTagline || "");

      if (companyLogo) {
        formData.append("CompanyLogo", companyLogo);
      }

      delete ApiClient.defaults.headers["Content-Type"];

      const resp = await ApiClient.patch("/User/update-user-company", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return resp;
    } catch (error) {
      console.error("❌ Error updating company profile:", error.response?.data || error.message);
      throw error;
    }
  },

  async updateUserProfile(userData, profileImage) {
    try {
      const formData = new FormData();

      formData.append("firstName", userData.firstName || "");
      formData.append("lastName", userData.lastName || "");
      formData.append("email", userData.email || "");
      formData.append("whatsAppNo", userData.whatsAppNo || "");
      formData.append("businessDetails", userData.businessDetails || "");

      // Append image only if available
      if (profileImage) {
        formData.append("UserPic", profileImage);
      }

      delete ApiClient.defaults.headers["Content-Type"];

      const resp = await ApiClient.patch("/User/update-user-profile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("✅ Profile update response:", resp.data);
      return resp;
    } catch (error) {
      console.error(" Error updating user profile:");
      console.error("Response:", error.response?.data || error.message);
      throw error;
    }
  },

  //update-password
  async updateUserPassword(userData) {
    try {
      const resp = await ApiClient.patch("/User/update-user-password", userData);
      return resp;
    } catch (error) {
      console.error("❌ Error occured while changing password:", error.response?.data || error.message);
      throw error;
    }
  },

  //update-email
  async updateUserEmail(userData) {
    try {
      const resp = await ApiClient.patch("/User/update-user-email", userData);
      return resp;
    } catch (error) {
      console.error("❌ Error occured while changing email:", error.response?.data || error.message);
      throw error;
    }
  },
  //update-phone
  async updateUserPhone(userData) {
    try {
      const resp = await ApiClient.patch("/User/update-user-phone", userData);
      return resp;
    } catch (error) {
      console.error("❌ Error occured while changing phone:", error.response?.data || error.message);
      throw error;
    }
  },
  async sendProfileOtp(userData) {
    try {
      const resp = await ApiClient.post("/User/user-account-verification", userData);
      return resp;
    } catch (error) {
      console.error("❌ Error sending otp:", error.response?.data || error.message);
      throw error;
    }
  },

  async verifyProfileOtp(userData) {
    try {
      const resp = await ApiClient.post("/User/user-account-verify-otp", userData);
      return resp;
    } catch (error) {
      console.error("❌ Error verifying otp:", error.response?.data || error.message);
      throw error;
    }
  },

};


export default UserService;